import {
  Burger,
  Center,
  Flex,
  Header as MantineHeader,
  Image,
  MediaQuery,
  Text,
  useMantineTheme,
  createStyles,
  rem,
  Group,
  Overlay,
  CloseButton,
  Stack,
  Box,
} from "@mantine/core";
import { useState } from "react";
import DemoBanner from "./components/DemoBanner";
import { isDemoOnly } from "./demo";

const NAV_ITEMS = [
  {
    label: "主頁",
    link: "/",
  },
  {
    label: "關於我們",
    link: "/#關於我們",
  },
  {
    label: "服務",
    link: "/#服務",
  },
  {
    label: "收費",
    link: "/#收費",
  },
  {
    label: "聯絡我們",
    link: "/#聯絡我們",
  },
];

const HEADER_HEIGHT = 80;
const DEMO_BANNER_HEIGHT = 36;

const useStyles = createStyles((theme) => ({
  brandName: {
    color: theme.colors.gray[7],
    fontSize: theme.fontSizes.md,
    fontWeight: 500,
  },
  link: {
    display: "block",
    lineHeight: 1,
    padding: `${rem(8)} ${rem(12)}`,
    borderRadius: theme.radius.sm,
    textDecoration: "none",
    color: theme.colors.gray[7],
    fontSize: theme.fontSizes.md,
    fontWeight: 500,

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },

    [theme.fn.smallerThan("sm")]: {
      borderRadius: 0,
      padding: theme.spacing.md,
    },
  },

  mobileLink: {
    "&:hover": {
      backgroundColor: "unset",
    },
  },
}));

export default function Header() {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const { classes } = useStyles();
  const headerHeight = isDemoOnly
    ? HEADER_HEIGHT + DEMO_BANNER_HEIGHT
    : HEADER_HEIGHT;

  return (
    <MantineHeader height={{ base: headerHeight }} p={0} bg="#fed703">
      <DemoBanner />
      <Box p="sm">
        <MediaQuery largerThan="sm" styles={{ display: "none" }}>
          <Flex align="center">
            <Flex align="center" sx={{ flex: 1 }} gap={12}>
              <Image
                src="/logo512.png"
                alt="master wong logo 512"
                height={60}
                width="auto"
              />
              <Text className={classes.brandName}>Master wong</Text>
            </Flex>
            <Burger
              opened={opened}
              onClick={() => setOpened((o) => !o)}
              size="sm"
              color={theme.colors.gray[6]}
            />

            <Overlay
              fixed
              blur={20}
              bg={"#fed703"}
              sx={{
                visibility: opened ? "unset" : "hidden",
                opacity: opened ? 1 : 0,
                transition: "opacity 0.2s ease-in-out",
              }}
            >
              <CloseButton
                mt={"lg"}
                ml={"auto"}
                size={"xl"}
                sx={{
                  "&:hover": {
                    background: "unset",
                  },
                }}
                onClick={() => setOpened(false)}
              />
              <Stack spacing={"xs"}>
                {NAV_ITEMS.map((link) => (
                  <a
                    key={link.label}
                    href={link.link}
                    className={[classes.link, classes.mobileLink].join(" ")}
                    onClick={(event) => {
                      event.preventDefault();
                      setOpened(false);
                      window.location.href = link.link;
                    }}
                  >
                    {link.label}
                  </a>
                ))}
              </Stack>
            </Overlay>
          </Flex>
        </MediaQuery>

        <MediaQuery smallerThan="sm" styles={{ display: "none" }}>
          <Center>
            <Group
              position="apart"
              px={"lg"}
              sx={{ maxWidth: "820px" }}
              w={"100%"}
            >
              <Group>
                <Image
                  src="/logo512.png"
                  alt="master wong logo 512"
                  height={60}
                  width="auto"
                />
                <Text className={classes.brandName}>Master Wong</Text>
              </Group>
              <Group spacing={"xs"}>
                {NAV_ITEMS.map((link) => (
                  <a key={link.label} href={link.link} className={classes.link}>
                    {link.label}
                  </a>
                ))}
              </Group>
            </Group>
          </Center>
        </MediaQuery>
      </Box>
    </MantineHeader>
  );
}
